import { useQuery } from '@tanstack/react-query'
import { throwIfApiError } from 'utils/error-handling/throwifApiError'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { requestDataToRequestRows } from '@omnea-app/fe-requests/useRequestTableRows'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'
import { paths } from '@omnea-app/requests/requestsHttpClient/requestsGeneratedTypes'

type TopLevelFilter = NonNullable<paths['/paginated']['post']['requestBody']>['content']['application/json']['topLevelFilter']

const DASHBOARD_MAX_TABLE_ROWS = 4
interface UseRequestsBaseParams {
  topLevelFilter: TopLevelFilter
}
export function useRequestsBase({ topLevelFilter }: UseRequestsBaseParams) {
  const { getToken } = useAuthenticatedUser()
  const { user } = useAuthenticatedUser()

  return useQuery({
    queryKey: ['dashboard-requests', topLevelFilter],
    queryFn: async () => {
      const authorization = await getToken()
      const requestsClient = new RequestsHttpClient({ authorization })
      const { data, error } = await requestsClient.POST('/paginated', {
        body: {
          topLevelFilter,
          paginationModel: { page: 0, pageSize: DASHBOARD_MAX_TABLE_ROWS },
          filterModel: null,
          sorting: null,
        },
      })
      throwIfApiError(error)
      if (data && 'cantPaginate' in data) throw new Error('cant fetch requests')
      const requests = data?.requests
      return requestDataToRequestRows(requests, user.id)
    },
  })
}
